{
  "title": "Facturation",
  "description": "Gérez votre abonnement et les paiements de vos campagnes publicitaires.",
  "tabs": {
    "subscription": "Abonnement",
    "adCampaigns": "Campagnes publicitaires"
  },
  "subscription": {
    "price": "Prix",
    "expires": "Expire le",
    "plan": "plan",
    "statusActive": "Actif",
    "statusPending": "Paiement en attente",
    "completePayment": "Effectuer le paiement",
    "starting": "Démarrage…",
    "upgradeToPremium": "Passer à Premium",
    "upgrading": "Mise à niveau…",
    "activated": "Abonnement Premium activé",
    "paymentProcessing": "Le paiement est en cours. Actualisez dans quelques instants si les fonctionnalités restent verrouillées.",
    "payError": "Échec du démarrage du paiement",
    "upgradeSuccess": "Passé à Premium. Effectuez le paiement pour activer.",
    "upgradeError": "Échec de la mise à niveau",
    "couldNotStart": "Impossible de démarrer le paiement"
  },
  "adCampaigns": {
    "empty": "Aucune campagne publicitaire pour l'instant.",
    "create": "Créer une campagne",
    "viewAll": "Voir toutes les campagnes"
  }
}
